import {StyleSheet} from "aphrodite";
import * as React from "react";

import {addStyle, type StyleType} from "@khanacademy/wonder-blocks-core";
import {semanticColor, spacing} from "@khanacademy/wonder-blocks-tokens";
import {HeadingXSmall} from "@khanacademy/wonder-blocks-typography";

interface Props {
    tag?: string;
    children: React.ReactNode;
    label: string;
    style?: StyleType;
}

const StyledSection = addStyle("section");

function NavSection({
    tag = "h3",
    children,
    label,
    style,
}: Props): React.ReactElement {
    return (
        <StyledSection style={[styles.navSection, style]}>
            {/* Though this is stylistically an h4 heading, we want it to
            appear to screenreaders as an h3. */}
            <HeadingXSmall tag={tag} style={styles.heading}>
                {label}
            </HeadingXSmall>
            <ul>{children}</ul>
        </StyledSection>
    );
}

const styles = StyleSheet.create({
    navSection: {
        marginBlockStart: spacing.large_24,
        marginBlockEnd: spacing.large_24,

        // Between two nav sections, we produce an xLarge gap between them
        // instead. Note that this *collapses* with the next section's
        // marginTop, rather than summing with it, for a total of xLarge rather
        // than xLarge + large.
        ":not(:last-of-type)": {
            marginBottom: spacing.xLarge_32,
        },
    },

    heading: {
        color: semanticColor.core.foreground.neutral.subtle,
        marginBlockEnd: spacing.small_12,
        marginInlineStart: spacing.large_24,
    },
});

export default NavSection;
